import { Col, Container, Row } from "react-grid-system";
import theme from "@config/theme";
import webinarData from "@content/en/webinars/webinars.yaml";
import Breadcrumbs from "@components/Breadcrumbs";
import CardLayout from "@components/layout/CardLayout";
import Tags from "@components/Tags";
import { formatPublishDate, stringToURI } from "@scripts/utils";
import FeaturedWebinar from "./FeaturedWebinar";

const WebinarListPage = () => {
  const { webinars } = webinarData;
  const featuredWebinars = webinars.filter((webinar) => webinar.featured);
  if (featuredWebinars.length !== 1) {
    throw new Error("There must only be one featured webinar.");
  }
  const featuredWebinar = featuredWebinars[0];
  const notFeaturedWebinars = webinars.filter((webinar) => !webinar.featured);

  const featuredWebinarLink =
    featuredWebinar.signUpLink ||
    `/webinars/${stringToURI(featuredWebinar.title)}`;

  return (
    <>
      <Container>
        <Row>
          <Col md={12} lg={8}>
            <Breadcrumbs links={[{ name: "Webinars", url: "/webinars" }]} />
            <h1>Webinars</h1>
            <p>
              At Blues we hold regular webinars to release products, introduce
              partners, and interact with the broader Blues developer community. 
              Join us live to ask questions and get involved!
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <FeaturedWebinar
              link={featuredWebinarLink}
              date={formatPublishDate(featuredWebinar.date)}
              title={featuredWebinar.title}
              description={featuredWebinar.shortDescription}
              image={featuredWebinar.image}
              tags={featuredWebinar.tags || []}
            />

            <hr />

            <CardLayout
              cards={notFeaturedWebinars.map((webinar) => ({
                link: `/webinars/${stringToURI(webinar.title)}`,
                description: webinar.shortDescription,
                banner: webinar.image,
                date: formatPublishDate(webinar.date),
                headerExtra: (
                  <p className="publish-date">
                    {formatPublishDate(webinar.date)}
                  </p>
                ),
                footerExtra: (
                  <>
                    <Tags
                      tags={
                        webinar.tags
                          ? webinar.tags.map((tag) => ({ name: tag }))
                          : []
                      }
                    />
                  </>
                ),
              }))}
            />
          </Col>
        </Row>
      </Container>
      <style jsx>{`
        hr {
          border: none;
          border-top: 1px solid ${theme.colors.gray4};
          margin: 2rem 0 3rem 0;
        }

        .publish-date {
          margin-bottom: 0;
          color: ${theme.colors.gray3};
        }

        :global(.card .overlay) {
          display: none;
        }
        :global(.card .header) {
          aspect-ratio: 16 / 9 !important;
        }
      `}</style>
    </>
  );
};

export default WebinarListPage;
